import { inject, Injectable, signal } from '@angular/core';
import {
  EntityType,
  GetParentTypesQueryService,
  GetPregnancyStatusesQueryService,
  GetUserQueryService,
  GetWalletQueryService,
  UpdateUserMutationService,
  UserHaveAccessToEntityQueryService,
  UserArgs,
  Wallet,
} from '@shared/graphql/api.generated';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly getParentTypesQueryService = inject(GetParentTypesQueryService);
  private readonly getPregnancyStatusesQueryService = inject(GetPregnancyStatusesQueryService);
  private readonly getUserQueryService = inject(GetUserQueryService);
  private readonly updateUserMutationService = inject(UpdateUserMutationService);
  private readonly getWalletQueryService = inject(GetWalletQueryService);
  private readonly userHaveAccessToEntityQueryService = inject(UserHaveAccessToEntityQueryService);
  private readonly tokenService = inject(TokenService);

  public walletInfo = signal<Wallet | null>(null);

  constructor() {}

  public getParentTypes(parentGender: number) {
    return this.getParentTypesQueryService.fetch({
      filter: {
        gender: {
          equals: parentGender,
        },
      },
    });
  }

  public getPregnancyStatuses() {
    return this.getPregnancyStatusesQueryService.fetch();
  }

  public updateProfile(data: UserArgs) {
    return this.updateUserMutationService.mutate({
      data: data,
    });
  }

  public getUserProfile() {
    return this.getUserQueryService.fetch();
  }

  public fetchWallet() {
    if (this.tokenService.getRtk()) {
      this.getWalletQueryService.fetch().subscribe({
        next: (res) => {
          this.walletInfo.set(res.data.getMyWallet as Wallet);
        },
      });
    }
  }

  public isPurchasedByUser(id: number, type: EntityType) {
    return this.userHaveAccessToEntityQueryService.fetch({
      id,
      type,
    });
  }
}
